<template>
    <div v-loading="timetableLoading" element-loading-text="课表信息加载中，请稍候..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
        <!--
        <div style="margin: 5px 10px 5px 10px;">
            <el-select v-model="queryForm.siteCode" filterable placeholder="请选择需要查询场地" style="width:400px;" @change="handleSiteChange" filterable>
                <el-option v-for="item in comboOption.site" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
        </div>
        -->
        <el-row style="margin-top:-10px;">
            <el-col :span="5" class="row-label">
                <el-input style="width:100%; margin-bottom:10px;" placeholder="场地查询" clearable v-model="treeFilterText"></el-input>
                <div ref="mainDiv" class="tree-container" :style="{width:'100%', height:mainDivHeight+20+'px', overflow:'auto'}">
                    <el-tree ref="siteTree" :data="siteData" node-key="id" :props="defaultProps"
                        :default-expanded-keys="['0']" @node-click="handleNodeClick" :filter-node-method="filterNode">
                    </el-tree>
                </div>
            </el-col>
            <el-col :span="19" class="row-label">
                <el-select v-model="queryForm.weekNum" filterable placeholder="全部周次" style="width:200px;" @change="handleWeekChange" clearable>
                    <el-option v-for="item in comboOption.week" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                    </el-option>
                </el-select>
                <table class="timetable timetableHead">
                    <tr>
                        <td class="timetableTitle separetor" style="width:15.2%;">{{ curSiteName }}</td>
                        <td v-for="colNum in weekDayNum"
                            class="timetableTitle separetor"
                            :style="{width: 84.8/weekDayNum + '%'}"
                            v-html="weekDayName[colNum-1] + (weekDayDate?'<br/>'+weekDayDate[colNum-1]:'')">
                        </td>
                    </tr>
                </table>
                <div id="oriTimetable" class="timetable-container" :style="{height: timetableHeight + 'px'}">
                    <table class="timetable">
                        <tr v-if="forenoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle separetor" :rowspan="forenoonNum" style="width:3%;">上<br/><br/>午</td>
                            <td class="timetableTitle" style="width:2%;">1</td>
                            <td class="timetableTitle" style="width:10%">{{ timeQuantum[0] }}</td>
                            <!-- <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + (colNum-1)"
                                :style="{width: 85/weekDayNum + '%'}"
                                :title="formatTimetableTitle(colNum-1)"
                                v-html="formatTimetableHtml(colNum-1)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouserLeave"> -->
                            <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + (colNum-1)"
                                :style="{width: 85/weekDayNum + '%'}"
                                v-html="formatTimetableHtml(colNum-1)">
                            </td>
                        </tr>
                        <template v-if="forenoonNum > 1">
                            <tr v-for="rowNum in forenoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                                <td :class="rowNum < forenoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ rowNum + 1 }}
                                </td>
                                <td :class="rowNum < forenoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ timeQuantum[rowNum] }}
                                </td>
                               <!-- <td v-for="colNum in weekDayNum"
                                    :class="rowNum < forenoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + rowNum*weekDayNum)"
                                    :title="formatTimetableTitle((colNum-1) + rowNum*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + rowNum*weekDayNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouserLeave"> -->
                                <td v-for="colNum in weekDayNum"
                                    :class="rowNum < forenoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + rowNum*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + rowNum*weekDayNum)">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="noonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle separetor" :rowspan="noonNum">中<br/><br/>午</td>
                            <td class="timetableTitle">1</td>
                            <td class="timetableTitle">{{ timeQuantum[forenoonNum] }}</td>
                            <!-- <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + forenoonNum*weekDayNum)"
                                :title="formatTimetableTitle((colNum-1) + forenoonNum*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + forenoonNum*weekDayNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouserLeave"> -->
                            <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + forenoonNum*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + forenoonNum*weekDayNum)">
                            </td>
                        </tr>
                        <template v-if="noonNum > 1">
                            <tr v-for="rowNum in noonNum-1" :style="{height: timetableRowHeight + 'px'}">
                                <td :class="rowNum < noonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ rowNum + 1 }}
                                </td>
                                <td :class="rowNum < noonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ timeQuantum[forenoonNum+rowNum] }}
                                </td>
                                <!-- <td v-for="colNum in weekDayNum"
                                    :class="rowNum < noonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+rowNum)*weekDayNum)"
                                    :title="formatTimetableTitle((colNum-1) + (forenoonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+rowNum)*weekDayNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouserLeave"> -->
                                <td v-for="colNum in weekDayNum"
                                    :class="rowNum < noonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+rowNum)*weekDayNum)">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="afternoonNum > 0" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle separetor" :rowspan="afternoonNum">下<br/><br/>午</td>
                            <td class="timetableTitle">1</td>
                            <td class="timetableTitle">{{ timeQuantum[forenoonNum+noonNum] }}</td>
                            <!-- <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum)*weekDayNum)"
                                :title="formatTimetableTitle((colNum-1) + (forenoonNum+noonNum)*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum)*weekDayNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouserLeave"> -->
                            <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum)*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum)*weekDayNum)">
                            </td>
                        </tr>
                        <template v-if="afternoonNum > 1">
                            <tr v-for="rowNum in afternoonNum-1" :style="{height: timetableRowHeight + 'px'}">
                                <td :class="rowNum < afternoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ rowNum+1 }}
                                </td>
                                <td :class="rowNum < afternoonNum-1 ? 'timetableTitle' : 'timetableTitle separetor'">
                                    {{ timeQuantum[forenoonNum+noonNum+rowNum] }}
                                </td>
                                <!-- <td v-for="colNum in weekDayNum"
                                    :class="rowNum < afternoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+rowNum)*weekDayNum)"
                                    :title="formatTimetableTitle((colNum-1) + (forenoonNum+noonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+rowNum)*weekDayNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouserLeave">
                                </td> -->
                                <td v-for="colNum in weekDayNum"
                                    :class="rowNum < afternoonNum-1 ? 'timetableContent' : 'timetableContent separetor'"
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+rowNum)*weekDayNum)">
                                </td>
                            </tr>
                        </template>
                        <tr v-if="eveningNum > 0" :style="{height: timetableRowHeight + 'px'}">
                            <td class="timetableTitle" :rowspan="eveningNum">晚<br/><br/>上</td>
                            <td class="timetableTitle">1</td>
                            <td class="timetableTitle">{{ timeQuantum[forenoonNum+noonNum+afternoonNum] }}</td>
                            <!-- <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+afternoonNum)*weekDayNum)"
                                :title="formatTimetableTitle((colNum-1) + (forenoonNum+noonNum+afternoonNum)*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+afternoonNum)*weekDayNum)"
                                @mouseenter="handleCellMouseEnter"
                                @mouseleave="handleCellMouserLeave"> -->
                            <td v-for="colNum in weekDayNum"
                                class="timetableContent"
                                :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+afternoonNum)*weekDayNum)"
                                v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+afternoonNum)*weekDayNum)">
                            </td>
                        </tr>
                        <template v-if="eveningNum > 1">
                            <tr v-for="rowNum in eveningNum-1" :style="{height: timetableRowHeight + 'px'}">
                                <td class="timetableTitle">
                                    {{ rowNum+1 }}
                                </td>
                                <td class="timetableTitle">
                                    {{ timeQuantum[forenoonNum+noonNum+afternoonNum+rowNum] }}
                                </td>
                                <!-- <td v-for="colNum in weekDayNum"
                                    class="timetableContent"s
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+afternoonNum+rowNum)*weekDayNum)"
                                    :title="formatTimetableTitle((colNum-1) + (forenoonNum+noonNum+afternoonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+afternoonNum+rowNum)*weekDayNum)"
                                    @mouseenter="handleCellMouseEnter"
                                    @mouseleave="handleCellMouserLeave"> -->
                                <td v-for="colNum in weekDayNum"
                                    class="timetableContent"s
                                    :id="'teaCell_' + ((colNum-1) + (forenoonNum+noonNum+afternoonNum+rowNum)*weekDayNum)"
                                    v-html="formatTimetableHtml((colNum-1) + (forenoonNum+noonNum+afternoonNum+rowNum)*weekDayNum)">
                                </td>
                            </tr>
                        </template>
                    </table>
                </div>
                <div id="finalTimetable" class="timetable-container" :style="{height: timetableHeight + 'px', display:'none'}">
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                    siteCode: null,
                    weekNum: null,
                    showDivideCourse: true,
                },
                comboOption: {
                    site: null,
                    week: null,
                },
                siteData: [],
                mainDivHeight: 500,
                tableLoading: true,
                curSiteName: null,
                //课表基本参数
                weekDayNum: null,
                weekDayName: null,
                weekDayDate: null,
                forenoonNum: null,
                noonNum: null,
                afternoonNum: null,
                eveningNum: null,
                totalNum: null,
                forenoonOrderArray: null,
                noonOrderArray: null,
                afternoonOrderArray: null,
                eveningOrderArray: null,
                timeQuantum: [],
                timetableHeight: 500,
                timetableRowHeight: 60,
                //课表内容
                timetableInfo: [],
                timetableLoading: false,
                treeFilterText: null,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
            }
        },
        mounted() {
            this.$nextTick().then(() => {
               this.queryTree();
               this.initCombo();
               this.initBlankTimetable();
            });
        },
        watch: {
            treeFilterText(val) {
                this.$refs.siteTree.filter(val);
            }
        },
        methods: {
            queryTree() {
                this.$api.timetableManage.siteTimetable.queryTree({
                    data: this.queryForm
                }).then((response) => {
                    this.siteData = response.data.data
                }).catch(error => {
                    console.log(error);
                });
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            initCombo() {
                this.$api.timetableManage.siteTimetable.initCombo({
                    data: this.queryForm
                }).then((res) => {
                    // this.comboOption.site = res.data.data.siteComboData;
                    this.comboOption.week = res.data.data.weekComboData;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            handleSiteChange(){
                this.querySiteTimetable();
            },
            handleWeekChange(){
                this.querySiteTimetable();
            },
            //点击node
            handleNodeClick(node) {
                if (node.type === 'site') {
                    this.curSiteName = node.label;
                    this.queryForm.siteCode = node.id;
                    this.querySiteTimetable();
                }
            },
            initBlankTimetable() {
                this.$api.timetableManage.common.baseParam({
                    data: this.queryForm
                }).then((res) => {
                    this.weekDayNum = parseInt(res.data.data.baseParam.weekDayNum, 10);
                    this.weekDayName = res.data.data.baseParam.weekDayName.split(',');
                    this.forenoonNum = parseInt(res.data.data.baseParam.forenoonNum, 10);
                    this.noonNum = parseInt(res.data.data.baseParam.noonNum, 10);
                    this.afternoonNum = parseInt(res.data.data.baseParam.afternoonNum, 10);
                    this.eveningNum = parseInt(res.data.data.baseParam.eveningNum, 10);
                    this.totalNum = this.forenoonNum + this.noonNum + this.afternoonNum + this.eveningNum;
                    this.forenoonOrderArray = this.generateOrderDetailInfo(0, this.forenoonNum);
                    this.noonOrderArray = this.generateOrderDetailInfo(this.forenoonNum, this.noonNum);
                    this.afternoonOrderArray = this.generateOrderDetailInfo(this.forenoonNum + this.noonNum, this.afternoonNum);
                    this.eveningOrderArray = this.generateOrderDetailInfo(this.forenoonNum + this.noonNum + this.afternoonNum, this.eveningNum);

                    //生成上课时间信息
                    const timeQuantumArray = res.data.data.baseParam.timeQuantum.split(',');
                    const _this = this;
                    this.timeQuantum = new Array();
                    timeQuantumArray.forEach(element => {
                        _this.timeQuantum.push(element.split('@')[1]);
                    });

                    this.handleTimetableRowHeight();
                }).catch((err) => {
                    console.log(err);
                });
            },
            generateOrderDetailInfo(startIndex, num){
                let orderArray = new Array();

                for(let i=0; i<num; i++){
                    let tempOrder = startIndex + i + 1;
                    orderArray.push(tempOrder<10 ? '0'+tempOrder : tempOrder.toString());
                }

                return orderArray;
            },
            handleTimetableRowHeight(){
                this.timetableHeight = this.mainDivHeight - 40;

                //默认高度60，内容高度低于总高度自动拉伸
                if(this.totalNum * 60 < this.timetableHeight){
                    this.timetableRowHeight = this.timetableHeight / this.totalNum;
                }else{
                    this.timetableRowHeight = 60;
                }
            },
            querySiteTimetable() {
                this.timetableLoading = true;

                this.$api.timetableManage.query.site({
                    data: this.queryForm,
                }).then((response) => {
                    this.timetableInfo = response.data.data.timetable.cellList;
                    this.weekDayDate = response.data.data.weekdayDate;

                    this.$nextTick().then(() => {
                        this.mergeCell();
                    });
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.timetableLoading = false;
                });
            },
            formatTimetableHtml(index){
                let contentStr = '';
                const info = this.timetableInfo[index];

                if (info && info.courseName) {
                    if(info.courseName.indexOf('｜') < 0){
                        contentStr = info.courseName;
                        // if (contentStr.indexOf(this.separator)<0 && contentStr.length>13) {
                        //     contentStr = contentStr.substring(0, 10) + '……';
                        // }
                        if (info.className != null) contentStr += '<br/>' + info.className;
                        if (info.teaName != null) contentStr += '<br/>' + info.teaName;
                        if (info.weekNum != null) contentStr += "<br/>" + info.weekNum;
                    }else{
                        const tempCourseNameArray = info.courseName.split('｜');
                        const tempClassNameArray = info.className.split('｜');
                        const tempTeaNameArray = info.teaName.split('｜');
                        const tempWeekNumArray = info.weekNum.split('｜');

                        for(let i=0; i<tempCourseNameArray.length; i++){
                            contentStr += '<br/>';

                            contentStr += tempCourseNameArray[i];
                            if(info.className!=null && tempClassNameArray.length>i) contentStr += '<br/>'+tempClassNameArray[i];
                            if(info.teaName!=null && tempTeaNameArray.length>i) contentStr += '<br/>'+tempTeaNameArray[i];
                            if(info.weekNum!=null && tempWeekNumArray.length>i) contentStr += '<br/>'+tempWeekNumArray[i];

                            contentStr += '<br/>';
                        }
                        contentStr += '<br/>';
                    }
                }

                return contentStr;
            },
            formatTimetableTitle(index){
                let contentStr = '';
                const info = this.timetableInfo[index];

                if (info && info.courseName) {
                    if(info.courseName.indexOf('｜') < 0){
                        contentStr = info.courseName;
                        if (info.className != null) contentStr += '\n' + info.className;
                        if (info.teaName != null) contentStr += '\n' + info.teaName;
                        if (info.weekNum != null) contentStr += "\n" + info.weekNum;
                    }else{
                        const tempCourseNameArray = info.courseName.split('｜');
                        const tempClassNameArray = info.className.split('｜');
                        const tempTeaNameArray = info.teaName.split('｜');
                        const tempWeekNumArray = info.weekNum.split('｜');

                        for(let i=0; i<tempCourseNameArray.length; i++){
                            contentStr += '\n';

                            contentStr += tempCourseNameArray[i];
                            if(info.className!=null && tempClassNameArray.length>i) contentStr += '\n'+tempClassNameArray[i];
                            if(info.teaName!=null && tempTeaNameArray.length>i) contentStr += '\n'+tempTeaNameArray[i];
                            if(info.weekNum!=null && tempWeekNumArray.length>i) contentStr += '\n'+tempWeekNumArray[i];

                            contentStr += '\n';
                        }
                        contentStr += '\n';
                    }
                }

                return contentStr;
            },
            mergeCell(){
                $('#finalTimetable').empty();
                $('#finalTimetable').append($('#oriTimetable').children().clone());
                $('#oriTimetable').hide();
                this.$nextTick().then(() => {
                    $('#finalTimetable').show();
                });

                //修改单元格id
                $('#finalTimetable .timetableContent').each(function(){
                    $(this).attr('id', 'final_' + $(this).attr('id'));
                });

                //处理可以合并的单元格
                const lastIndex = this.weekDayNum * this.totalNum - 1;
                for(let i=0; i<this.weekDayNum; i++){
                    for(let j=0; j<this.totalNum; j++){
                        const index = this.weekDayNum*j + i;
                        let curCell = $('#final_teaCell_' + index);

                        //判断单元格有效并且不是最后单元格
                        if(curCell && this.timetableInfo[index].courseName && index<lastIndex){
                            let sameFlag = true;
                            let sameNum = 1;
                            let mergeOrderArray = new Array();
                            mergeOrderArray.push(this.timetableInfo[index].orderNum.substring(2));

                            while(sameFlag){
                                const tempIndex = index + sameNum*this.weekDayNum;
                                if(tempIndex > lastIndex){
                                    break;
                                }

                                let tempCell = $('#final_teaCell_' + tempIndex);
                                if(curCell.html() === tempCell.html()
                                    && this.isSameTimeRange(this.timetableInfo[index].orderNum, this.timetableInfo[tempIndex].orderNum)){
                                    mergeOrderArray.push(this.timetableInfo[tempIndex].orderNum.substring(2));
                                    tempCell.remove();
                                    sameNum++;
                                }else{
                                    sameFlag = false;
                                }
                            }

                            if(sameNum > 1){
                                curCell.attr('rowspan', sameNum);

                                //判断是否需要添加分割线
                                if(mergeOrderArray[mergeOrderArray.length-1]===this.forenoonOrderArray[this.forenoonOrderArray.length-1]
                                    || mergeOrderArray[mergeOrderArray.length-1]===this.noonOrderArray[this.noonOrderArray.length-1]
                                    || mergeOrderArray[mergeOrderArray.length-1]===this.afternoonOrderArray[this.afternoonOrderArray.length-1]
                                    || mergeOrderArray[mergeOrderArray.length-1]===this.eveningOrderArray[this.eveningOrderArray.length-1]
                                ){
                                    curCell.addClass('separetor');
                                }
                            }
                        }
                    }
                }
            },
            isSameTimeRange(orderNum_1, orderNum_2){
                //判断是否同一天
                let dayNum_1 = orderNum_1.substring(0, 2);
                let dayNum_2 = orderNum_2.substring(0, 2);
                if(dayNum_1 === dayNum_2){
                    //判断是否同一时间区域（上午、中午、下午、晚上）
                    let timeNum_1 = orderNum_1.substring(2);
                    let timeNum_2 = orderNum_2.substring(2);
                    if((this.forenoonOrderArray.indexOf(timeNum_1)>-1 && this.forenoonOrderArray.indexOf(timeNum_2)>-1)
                        || (this.noonOrderArray.indexOf(timeNum_1)>-1 && this.noonOrderArray.indexOf(timeNum_2)>-1)
                        || (this.afternoonOrderArray.indexOf(timeNum_1)>-1 && this.afternoonOrderArray.indexOf(timeNum_2)>-1)
                        || (this.eveningOrderArray.indexOf(timeNum_1)>-1 && this.eveningOrderArray.indexOf(timeNum_2)>-1)
                    ){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                     return false;
                }
            },
            handleCellMouseEnter(ele){
                $('#' + ele.srcElement.id).css('background-color', '#FFE48D');
                this.showTitleInfo(ele.srcElement.id);
            },
            handleCellMouserLeave(ele){
                $('#' + ele.srcElement.id).css('background-color', '#FFFFFF');
                $('#' + ele.srcElement.id).attr('title', this.curTargetTitle);
                this.curTargetTitle = null;
                $("#div_toop").remove();
            },
            //显示title信息
            showTitleInfo(id){
                //获取title属性的内容
                this.curTargetTitle = $('#' + id).attr('title');

                if(this.curTargetTitle){
                    //设置元素title属性内容为空
                    $('#' + id).attr('title', '');

                    $("body").append("<div id='div_toop'>" + this.curTargetTitle.replace(/\n/g, '<br>') + "</div>");
                    $("#div_toop").css({
                        "position": "absolute",
                        "z-index": 999999,
                        "font-size": 12,
                        "background": "rgba(245, 245, 245, 0.9)",
                        "border": "solid 1px #A9A9A9",
                        "border-radius": "5px",
                        "padding": "5px",
                        "max-width": "200px"
                    });

                    $('#div_toop').css("top", $('#' + id).offset().top-$('#div_toop').height()+10 + "px");
                    $('#div_toop').css("left", $('#' + id).offset().left-$('#div_toop').width()+10 + "px");
                }
            },
        },
    }
</script>
<style scoped>
    .tree-container .el-tree {
        display: inline-block;
    }

    .tree-container /deep/ .el-tree__empty-block {
        position: absolute !important;
        width: 240px !important;
    }

    .timetable-container {
        border-left: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        overflow-x: auto;
        overflow-y: scroll;
    }

    .timetable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: center;
    }

    .timetableHead {
        border-left: 1px solid #DCDFE6;
        border-top: 1px solid #DCDFE6;
        width: calc(100% - 17px);
        margin-top: 5px;
    }

    .timetable tr {
        height: 59px;
    }

    .timetable td {
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        padding: 0;
    }

    .timetableTitle {
        background-color: #F1FAF6;
        font-weight: bold;
        color: #4e5053;
    }

    .timetableContent {
        font-size: 14px;
        color: #4e5053;
    }

    .separetor {
        border-bottom: 4px double #DCDFE6 !important;
    }
</style>



// WEBPACK FOOTER //
// siteTimetable.vue?715a8125